var React = require('react');

function NpDashBottomRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.60712 677C-18.9182 277.817 536.463 2 948 2","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"4 10"}));
}

NpDashBottomRight.defaultProps = {"width":"948","height":"678","viewBox":"0 0 948 678"};

module.exports = NpDashBottomRight;

NpDashBottomRight.default = NpDashBottomRight;
